import { Box, IconButton } from '@chakra-ui/react'
import { FaceBookHoverIcon, FaceBookIcon } from '../icons/faceBookIcon'
import { TwitterIcon, TwitterHoverIcon } from '../icons/twitterIcon'
import { WhatsappIcon, WhatsappIconHover } from '../icons/whatsappsIcon'
import { useState } from 'react'

export const DeathQuizShareButtons = ({ shareText, url, hashtags }) => {
  const isShareTextObject = typeof shareText === 'object'
  const whatsappShareText = isShareTextObject ? shareText.whatsapp : shareText
  const twitterShareText = isShareTextObject ? shareText.twitter : shareText
  const buttonDetails = [
    {
      icon: <WhatsappIcon />,
      hoverIcon: <WhatsappIconHover />,
      label: 'Whatsapp share',
      url: getWhatsappShareUrl({ text: whatsappShareText, url }),
    },
    {
      icon: <FaceBookIcon />,
      hoverIcon: <FaceBookHoverIcon />,
      label: 'Facebook share',
      url: getFacebookShareUrl({ url }),
    },
    {
      icon: <TwitterIcon />,
      hoverIcon: <TwitterHoverIcon />,
      label: 'Twitter share',
      url: getTwitterShareUrl({ text: twitterShareText, url, hashtags }),
    },
  ]
  let [iconHoverState, setIconHoverState] = useState({})
  return (
    <Box
      my={'15px'}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={'1em'}
    >
      {buttonDetails.map(({ icon, hoverIcon, label, url }) => (<>
        <IconButton
          as={'a'}
          background={'transparent'}
          border={'0px'}
          key={label}
          component={'a'}
          href={url}
          target='_blank'
          rel='noopener noreferrer'
          sx={{
            width: '56px',
            height: '56px',
            padding: '0',
          }}
          _hover={{
            bgColor: 'transparent'
          }}
          onMouseEnter={() => {
            setIconHoverState({...iconHoverState, [label]: true})
          }}
          onMouseLeave={() => {
            setIconHoverState({...iconHoverState, [label]: false})
          }}
        >
          {iconHoverState[label] ? hoverIcon : icon}
        </IconButton>
      </>
      ))}
    </Box>
  )
}

export function getTwitterShareUrl({ text, url, hashtags }) {
  const queryParams = ['text=' + encodeURIComponent(text)]
  if (url) queryParams.push('url=' + encodeURIComponent(url))
  if (hashtags) queryParams.push('hashtags=' + encodeURIComponent(hashtags))

  return `https://twitter.com/intent/tweet?` + queryParams.join('&')
}

export function getWhatsappShareUrl({ text, url }) {
  return `https://wa.me/?text=${encodeURIComponent(
    url ? `${text}\n\n${url}` : text
  )}`
}

export function getFacebookShareUrl({ url }) {
  return `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
}
